// Define your backend API URL here
// const springApiUrl = 'https://medi-back.techzap.lk:8443'; // Replace with your actual API URL
// const MySQLUrl = 'http://localhost:8080/api';
const MySQLUrl = 'https://admin.teegeeagency.lk/api';
// Export the API URL so it can be imported elsewhere
export default MySQLUrl;